<template>
    <v-container fluid fill-height id="mainContent" dark>
        <v-layout
                wrap
        >
            <v-flex cols="4" xs="4" md="4">
                <div align="center">
                <v-card
                        max-width="247"
                        tile
                        color="transparent"
                >
                    <v-row
                            align="end"
                            class="fill-height"
                    >
                        <v-col
                                cols="12"
                                color="transparent"
                        >
                            <v-avatar
                                    class="profile"
                                    width="247"
                                    height="329"
                                    tile
                            >
                                <v-img :src="profile.picture"></v-img>
                            </v-avatar>
                        </v-col>
                        <v-col>
                            <v-list-item dark>
                                <v-list-item-content class="text-center">
                                    <v-list-item-title class="title">{{profile.name}}</v-list-item-title>
                                    <v-list-item-subtitle>{{profile.position}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-card>
                </div>
            </v-flex>
            <v-flex cols="8" xs="8" md="8">
                <v-row
                        class="pa-3"
                        v-for="(skill, index) in profile.skills"
                        :key="index">
                    <v-col
                            sm="8"
                            class="pa-2"
                    >
                        <h2 class="pt-3 pb-3">{{skill.description}}</h2>
                        <v-card color="transparent">
                            <v-list color="transparent" dark>
                                <v-list-item v-bind:key="index" v-for="(item, index) in skill.items"
                                             class="pa-0 pl-1">
                                    <v-list-item-icon>
                                        <v-icon v-text="profile.bullet"></v-icon>
                                    </v-list-item-icon>
                                    {{item}}
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                </v-row>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "About",
        props: {
            profileData: {
                type: Object,
            }
        },
        data: function () {
            return {
                profile: this.profileData
            }
        }
    }
</script>

<style>

    .page--about {
        background-color: #263238;
        background-image: url('~@/assets/bg/about.png');
        background-position: center center;
        -ms-background-size: cover;
        -o-background-size: cover;
        -moz-background-size: cover;
        -webkit-background-size: cover;
        background-size: cover;
    }
</style>
